var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteAdvertisement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M165 271H15c-8.284 0-15 6.716-15 15v210c0 8.284 6.716 15 15 15h150c8.284 0 15-6.716 15-15V286c0-8.284-6.716-15-15-15zM497 271h-18.89c5.915 16.859 1.449 35.803-12.02 48.14l3.63 4.35c15.85 19 13.33 47.4-5.63 63.3l-51.72 43.41c-18.991 15.896-47.439 13.582-63.49-5.65l-3.51-4.21c-25.546 19.348-62.761 6.438-70.75-24.69L242.64 271H225c-8.28 0-15 6.72-15 15v210c0 8.28 6.72 15 15 15h272c8.28 0 15-6.72 15-15V286c0-8.28-6.72-15-15-15zM105 91c-8.271 0-15 6.729-15 15v15h30v-15c0-8.271-6.729-15-15-15zM210 91v60c16.542 0 30-13.458 30-30s-13.458-30-30-30z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497 1H15C6.72 1 0 7.72 0 16v210c0 8.28 6.72 15 15 15h219.94l-6.07-23.65c-9.525-37.143 28.977-68.444 63.36-51.61L446.12 241H497c8.28 0 15-6.72 15-15V16c0-8.28-6.72-15-15-15zM150 166c0 8.28-6.72 15-15 15s-15-6.72-15-15v-15H90v15c0 8.28-6.72 15-15 15s-15-6.72-15-15v-60c0-24.81 20.19-45 45-45s45 20.19 45 45zm60 15h-15c-8.28 0-15-6.72-15-15V76c0-8.28 6.72-15 15-15h15c33.08 0 60 26.92 60 60s-26.92 60-60 60zm225-15H315c-8.28 0-15-6.72-15-15s6.72-15 15-15h120c8.28 0 15 6.72 15 15s-6.72 15-15 15zm0-60H315c-8.28 0-15-6.72-15-15s6.72-15 15-15h120c8.28 0 15 6.72 15 15s-6.72 15-15 15z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.258 272.513 279.045 192.69c-11.471-5.61-24.294 4.829-21.12 17.203l45.755 178.296c2.74 10.676 15.709 14.85 24.162 7.77l21.344-17.881 22.736 27.255c5.306 6.361 14.79 7.228 21.161 1.882l51.726-43.404c6.333-5.314 7.172-14.751 1.876-21.099l-22.776-27.304 21.392-17.922c8.312-6.964 6.701-20.209-3.043-24.973z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteAdvertisement);
export default __webpack_public_path__ + "static/media/whiteAdvertisement.4ecf4a2ad605a0ef396c6f7c060b2691.svg";
export { ForwardRef as ReactComponent };